import dayjs from 'dayjs'
import { DateRange } from 'react-day-picker'

import { DATE_FORMAT } from '../constants'

export const formatDateRange = (value?: DateRange) => {
    if (value?.from && value?.to) {
        return dayjs(value.from).isSame(value.to, 'day')
            ? dayjs(value.to).format(DATE_FORMAT)
            : `${dayjs(value.from).format(DATE_FORMAT)}-${dayjs(value.to).format(DATE_FORMAT)}`
    }
}
